import React from 'react';
import PropTypes from 'prop-types';

import BarcodePrintingPage from '../components/App/BarcodePrinting/BarcodePrintingPage';

const PrintBarcodeRoute = ({ basePath }) => {
  return (
    <BarcodePrintingPage
      basePath={basePath}
    />
  );
};

PrintBarcodeRoute.propTypes = {
  basePath: PropTypes.string.isRequired,
};

export default PrintBarcodeRoute;
